import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TimelineTabSlider from "./TimelineTabSlider";
import TimelineSlider from "./TimelineSlider";

function Timelinetabs({ Tab_Modul }) {
    const [activeTab, setActiveTab] = useState(0);
    
    const handleNext = () => {
        if (activeTab < Tab_Modul.length - 1) {
            setActiveTab(prev => prev + 1);
        }
    };

    const handlePrev = () => {
        if (activeTab > 0) {
            setActiveTab(prev => prev - 1);
        }
    };

    return (
        <div className="tab_wrapper">
            {/* Nav Tabs */}
            {/* <ul className="nav nav-tabs">
                {Tab_Modul?.map((tab, index) => (
                    <li className="nav-item" key={tab.id}>
                        <button
                            className={`nav-link ${activeTab === index ? "active" : ""}`}
                            onClick={() => setActiveTab(index)}
                        >
                            {tab.Sub_Titel}
                        </button>
                    </li>
                ))}
            </ul> */}

            {/* Tab Content */}
            <div className="tab-content ">
                {/* {Tab_Modul?.[activeTab] && (
                    <TimelineTabSlider
                        tab={Tab_Modul[activeTab]}
                        onNext={handleNext}
                        onPrev={handlePrev}
                        isFirst={activeTab === 0}
                        isLast={activeTab === Tab_Modul.length - 1}
                    />
                )} */}
                {<TimelineSlider tabs={Tab_Modul} />}
            </div>
        </div>
    );
}

export default Timelinetabs;